import Table from './Table';
import TableBody from './TableBody';
import TableCell from './TableCell';
import TableFooter from './TableFooter';
import TableHeader from './TableHeader';
import TableRow from './TableRow';
import SortIndicator from './SortIndicator';

export { Table, TableBody, TableCell, TableFooter, TableHeader, TableRow, SortIndicator };

export default Table;
